// Route stub created by tools/gen_web_routes.py from contract/catalog/screens.json; owned by hand from here on (A7U5).
import { ids } from '@orca/api-client/testIds'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { PageHeader } from '../../components/ui/page-header'
import { PreferencesForm } from '../../features/preferences/PreferencesForm'
import '../../features/preferences/strings'

export const Route = createFileRoute('/account/preferences')({
  staticData: { screenId: 'PreferencesScreen', access: 'signed in' },
  component: PreferencesScreen,
})

function PreferencesScreen() {
  const { t } = useTranslation()
  return (
    <main data-testid={ids.preferences.root} className="flex flex-col gap-(--stack-lg)">
      <PageHeader title={t('preferences.title')}>
        <p className="text-fg-muted">{t('preferences.lede')}</p>
      </PageHeader>
      <PreferencesForm />
    </main>
  )
}
